export const staticText = {
  panel: {
    title: "Notifications",
    markAllRead: "Mark all as read",
    close: "Close notifications",
    empty: "No notifications",
    emptyUnread: "You don't have any new notifications.",
    tabs: {
      all: "All",
      unread: "Unread",
    },
  },
  actions: {
    bulkDownload: {
      expired: "This download has expired. Please request it again.",
    },
  },
};
